import * as React from 'react'
import TwitterCardCustom from 'components/TwitterCardCustom'
import { ScreenBreakPoint } from 'constants/index'
import styles from './TwitterSliderCustom.module.scss'
import { SlickSlider } from 'components/SlickSlider'

const NextArrow = (props) => {
	return (
		<div
			className={styles.next_arrow}
			onClick={props.onClick}
		/>
	)
}

const PrevArrow = (props) => {
	return (
		<div
			className={styles.prev_arrow}
			onClick={props.onClick}
		/>
	)
}

const sliderSettings = {
	swipeToSlide: true,
	slidesToShow: 4,
	speed: 300,
	autoplaySpeed: 6000,
	autoplay: false,
	prevArrow: <PrevArrow />,
	nextArrow: <NextArrow />,
	dots: false,
	infinite: true,
	slidesToScroll: 1,
	arrow: false,
	variableWidth: true,
	touchThreshold: 50,
	responsive: [
		{
			breakpoint: ScreenBreakPoint.xl - 1,
			settings: {
				slidesToShow: 4,
			},
		},
		{
			breakpoint: ScreenBreakPoint.lg - 1,
			settings: {
				slidesToShow: 4,
			},
		},
		{
			breakpoint: ScreenBreakPoint.md - 1,
			settings: {
				slidesToShow: 2,
			},
		},
		{
			breakpoint: ScreenBreakPoint.sm - 1,
			settings: {
				slidesToShow: 2,
			},
		},
	],
}

const data = [
	<TwitterCardCustom
		name={'Tony Federico'}
		image={'https://eightsleep.imgix.net/xPH5YsmC.jpg?v=1583513887'}
		altText="Twitter icon showing Red Tesla"
		handle={'@FitwithTfed'}
		text={`Freaking brilliant. This mattress is like my <span class="blue">#Tesla</span>. It gets better the longer I own it due to the updates I get!`}
		link="https://twitter.com/FitwithTfed/status/1227012635524259841"
		key="https://twitter.com/FitwithTfed/status/1227012635524259841"
		date="12:33 AM · Feb 11, 2020"
	/>,
	<TwitterCardCustom
		name="Kara"
		handle="@kbear80"
		image="https://eightsleep.imgix.net/ZqvnJPq8.jpg?v=1583514031"
		altText="Twitter Icon - Make our planet great again"
		text={`Thanks <span class="blue">@eightsleep</span>, for not only making a great product but having excellent customer service. I think I try`}
		readMore={true}
		link="https://twitter.com/kbear80/status/1220911574682152960"
		key="https://twitter.com/kbear80/status/1220911574682152960"
		date="4:29 AM · Jan 25, 2020"
	/>,
	<TwitterCardCustom
		text='I felt like I was logging into a space shuttle command center last night. So awesome. Happy <span class="blue">@eightsleep</span> user'
		link="https://twitter.com/AustinLieb/status/1215258030880755712"
		name="Austin Lieberman"
		handle="@7AustinL"
		image="https://eightsleep.imgix.net/6OCHLEuw_400x400_1baebfab-aa9e-4806-bbb1-834eaa3da8be.png?v=1583514820"
		altText="Smiling customer"
		key="https://twitter.com/AustinLieb/status/1215258030880755712"
		date="2:04 PM · Jan 9, 2020"
	/>,
	<TwitterCardCustom
		name={'Rob Madelmayer'}
		image="https://eightsleep.imgix.net/rob.png?v=1583515492"
		altText="Twitter icon - Rob"
		handle={'@RMadelmayer'}
		text={'Easy - <span class="blue">@eightsleep</span>. Temperature control is an absolute game changer. Full stop.'}
		link="https://twitter.com/RMadelmayer/status/1199721956012150785"
		key="https://twitter.com/RMadelmayer/status/1199721956012150785"
		date="5:09 PM · Nov 27, 2019"
	/>,

	<TwitterCardCustom
		name={'David Critten'}
		image="https://eightsleep.imgix.net/dave.jpg?v=1583515491"
		altText="Twitter icon - Dave"
		handle={'@Dave_Critten'}
		text={`<span class="blue">@eightsleep</span> best rest I've had in years`}
		link="https://twitter.com/Dave_Critten/status/1207462091738820608"
		key="https://twitter.com/Dave_Critten/status/1207462091738820608"
		date="1:46 AM · Dec 19, 2019"
	/>,

	<TwitterCardCustom
		name={'Ellen DaSilva'}
		image="https://eightsleep.imgix.net/ellen.jpg?v=1583515491"
		altText="Twitter icon - Ellen"
		handle={'@ellenjdasilva'}
		text={`Something I'm absolutely obsessed with right now is my pod from <span class="blue">@eightsleep</span>. I check my sleep stats religiously AND`}
		link="https://twitter.com/ellenjdasilva/status/1202333077290156032"
		readMore={true}
		key="https://twitter.com/ellenjdasilva/status/1202333077290156032"
		date="10:05 PM · Dec 4, 2019"
	/>,

	<TwitterCardCustom
		name={'Steven Chiocchi'}
		image="https://eightsleep.imgix.net/steven.jpg?v=1583515491"
		altText="Twitter icon - Steven"
		handle={'@StevenChiocchi'}
		text={`At first, skeptical about <span class="blue">@eightsleep</span>, but they nailed it. Struggled with "cooling sheets" and blankets for years until I tried`}
		link="https://twitter.com/StevenChiocchi/status/1136313830735265792"
		readMore={true}
		key="https://twitter.com/StevenChiocchi/status/1136313830735265792"
		date="6:48 PM · Jun 5, 2019"
	/>,

	<TwitterCardCustom
		name={'Greg Priester'}
		image="https://eightsleep.imgix.net/greg.jpg?v=1583515491"
		altText="Twitter icon - Greg"
		handle={'@_GreggyP'}
		text={`Three months into sleeping on my <span class="blue">@eightsleep</span> Pod mattress,  and I've got to say this bed is amazing! I could never have`}
		link="https://twitter.com/_GreggyP/status/1169446162379812864"
		readMore={true}
		key="https://twitter.com/_GreggyP/status/1169446162379812864"
		date="5:04 AM · Sep 5, 2019"
	/>,

	<TwitterCardCustom
		name={'John Egan'}
		image="https://eightsleep.imgix.net/john.jpg?v=1583515491"
		altText="Twitter icon - John"
		handle={'@john_m_egan'}
		text={`Once you go <span class="blue">@eightsleep</span> you never go back`}
		link="https://twitter.com/john_m_egan/status/1220141778982055936"
		key="https://twitter.com/john_m_egan/status/1220141778982055936"
		date="1:30 AM · Jan 23, 2020"
	/>,
]

const coverLPData = [
	<TwitterCardCustom
		name={'Anthony Pompliano'}
		image={'https://pbs.twimg.com/profile_images/1547787118243561478/PxWzJo1H_400x400.jpg'}
		altText="Twitter User"
		handle={'@APompliano'}
		text={`6/ The third most important thing I did to increase sleep quality was get a thermoregulating bed.
<br /><br />I've been sleeping on a <span class='blue'>@eightsleep</span> Pod Mattress and Pod Cover. <span class='blue'>@eightsleep.com</span><br /><br />The secret — I make it cold AF and magically get DEEP sleep.`}
		link="https://twitter.com/APompliano/status/1329608398770483200"
		key="https://twitter.com/APompliano/status/1329608398770483200"
	/>,
	<TwitterCardCustom
		name={'Louisa Nicola'}
		image={'https://pbs.twimg.com/profile_images/1499090034762395648/Im8C63Z2_400x400.jpg'}
		altText="Twitter User"
		handle={'@louisanicola_'}
		text={`I have the Pod Cover. It’s been the best change I have implemented`}
		link="https://twitter.com/louisanicola_/status/1412970196395073536"
		key="https://twitter.com/louisanicola_/status/1412970196395073536"
	/>,
	<TwitterCardCustom
		name="David Ulevitch"
		handle="@davidu"
		image="https://pbs.twimg.com/profile_images/1530185281843904512/e6JH2UUx_400x400.jpg"
		altText="Twitter User"
		text={`I have two homes and now have two <span class='blue'>@eightsleep</span>’s — one Pod Mattress and one Pod Cover. Big fan of both. I already had a new mattress for one bed so got cover.`}
		readMore={true}
		link="https://twitter.com/davidu/status/1360453347682099202"
		key="https://twitter.com/davidu/status/1360453347682099202"
	/>,
	<TwitterCardCustom
		text={`My <span class='blue'>@eightsleep</span> Pod Cover takes the next spot. I didn’t know what thermoregulation even was, but after seeing @Matteoceschetti’s passion for the subject of sleep fitness, it seemed worthwhile to dig in.<br /><br />So far it’s easy to say that it has given me the best sleep of my life.`}
		link="https://twitter.com/mg/status/1346492539281551360"
		name="Matt Galligan"
		handle="@mg"
		image="https://eightsleep.imgix.net/mg.jpg?v=1637324423"
		altText="Twitter User"
		key="https://eightsleep.imgix.net/mg.jpg?v=1637324423"
	/>,
	<TwitterCardCustom
		text={`I sleep really hot and have bought a bunch of self-proclaimed "cooling products" products over the years to try make myself more comfortable. None of them have made a difference.<br /><br />I slept on  <span class='blue'>@eightsleep</span>'s Pod Cover for the first time last night and... it actually works!`}
		link="https://twitter.com/maxwendkos/status/1343295667532394506"
		name="Max Wendkos"
		handle="@maxwendkos"
		image="https://pbs.twimg.com/profile_images/1366172005385596930/f__vrnow_200x200.jpg"
		altText="Twitter User"
		key="https://pbs.twimg.com/profile_images/1366172005385596930/f__vrnow_200x200.jpg"
	/>,
	<TwitterCardCustom
		text={`First night with <span class='blue'>@eightsleep</span> Pod Cover!  Wow me and the wife both noticed a difference night 1.`}
		link="https://twitter.com/ManRam2/status/1330557868244946944"
		name="Jesus Mu"
		handle="@ManRam2"
		image="https://pbs.twimg.com/profile_images/732955884716875776/SllBU2F0_200x200.jpg"
		altText="Twitter User"
		key="https://pbs.twimg.com/profile_images/732955884716875776/SllBU2F0_200x200.jpg"
	/>,
	<TwitterCardCustom
		text={`Pod Cover is moh-ney`}
		link="https://twitter.com/AaronSuplizio/status/1415519567141425153"
		name="Aaron Suplizio"
		handle="@AaronSuplizio"
		image="https://pbs.twimg.com/profile_images/1485777379075051522/3dF7aXYZ_400x400.jpg"
		altText="Twitter User"
		key="https://pbs.twimg.com/profile_images/1485777379075051522/3dF7aXYZ_400x400.jpg"
	/>,
	<TwitterCardCustom
		text={`i replaced my Ooler with <span class='blue'>@eightsleep</span> Pod Cover and glad I did<br /><br />way better design, quieter, and it's way more comfortable`}
		link="https://twitter.com/EricKentEdstrom/status/1419756393754726401"
		name="Eric Kent Edstrom"
		handle="@EricKentEdstrom"
		image="https://pbs.twimg.com/profile_images/1489659693580664833/oAILAqHv_400x400.jpg"
		altText="Twitter User"
		key="https://pbs.twimg.com/profile_images/1489659693580664833/oAILAqHv_400x400.jpg"
	/>,
	<TwitterCardCustom
		text={`<span class='blue'>@eightsleep</span> is the move. We bought a pod and I haven’t woken up sweaty once since then.`}
		link="https://twitter.com/Joe_Baer_74/status/1511836822795477000"
		name="Joe Baer"
		handle="@Joe_Baer_74"
		image="https://eightsleep.imgix.net/joe_baer.jpg?v=1658317292"
		altText="Twitter User"
		key="https://eightsleep.imgix.net/joe_baer.jpg?v=1658317292"
	/>,
	<TwitterCardCustom
		text={`The cover! Although starting to think I need to pick up the mattress too; my Casper is not looking it’s best anyway. Can’t recommend the cover enough if you’re on the fence.`}
		link="https://twitter.com/davidjshinn/status/1419756079861272597"
		name="Dave Shinn"
		handle="@davidjshinn"
		image="https://eightsleep.imgix.net/davidjshinn.jpg?v=1637324423"
		altText="Twitter User"
		key="https://eightsleep.imgix.net/davidjshinn.jpg?v=1637324423"
	/>,
	<TwitterCardCustom
		text={`We got the eightsleep mattress cover! WATERCOOLED BED!`}
		link="https://twitter.com/Aaraflynn/status/1418655470508720130"
		name="Flynn"
		handle="@Aaraflynn"
		image="https://pbs.twimg.com/profile_images/1540732489618145280/HjQSfHUx_400x400.jpg"
		altText="Twitter User"
		key="https://pbs.twimg.com/profile_images/1540732489618145280/HjQSfHUx_400x400.jpg"
	/>,
]

export interface TwitterSliderProps {
	isCoverOnly: boolean
}

/**
 * @deprecated Remove asap
 */
const TwitterSlider: React.FC<TwitterSliderProps> = (props) => {
	let twitterData = data
	if (props.isCoverOnly) {
		twitterData = coverLPData
	}

	const slides = twitterData.map((card) => ({ component: card }))

	return (
		<SlickSlider
			settings={sliderSettings}
			className={`arrows eight ${styles.root}`}
			items={slides}
		></SlickSlider>
	)
}

export default TwitterSlider
